var routeTitle = "";
var siteTitle = "";

function setTitle() {
  if (!routeTitle && !siteTitle) {
    document.title = "loading";
  } else if (routeTitle && !siteTitle) {
    document.title = routeTitle;
  } else if (!routeTitle && siteTitle) {
    document.title = siteTitle;
  } else {
    document.title = routeTitle + "-" + siteTitle;
  }
}

export default {
  //路由标题
  setRouteTitle(info) {
    routeTitle = info;
    setTitle();
  },
  //文章标题
  setSiteTitle(info) {
    siteTitle = info;
    setTitle();
  },
};
